export enum ReportJobInterval {
  DAILY = 'DAILY',
  WEEKLY_MONDAY = 'WEEKLY_MONDAY',
  WEEKLY_TUESDAY = 'WEEKLY_TUESDAY',
  WEEKLY_WEDNESDAY = 'WEEKLY_WEDNESDAY',
  WEEKLY_THURSDAY = 'WEEKLY_THURSDAY',
  WEEKLY_FRIDAY = 'WEEKLY_FRIDAY',
  WEEKLY_SATURDAY = 'WEEKLY_SATURDAY',
  WEEKLY_SUNDAY = 'WEEKLY_SUNDAY',
  MONTHLY = 'MONTHLY',
}
